// Безопасно получаем переменные окружения (с fallback для браузера)
const getEnvVar = (name, defaultValue) => {
    // В браузере Webpack DefinePlugin подставляет process.env.VARIABLE_NAME как константы
    try {
        switch (name) {
            case 'NODE_ENV':
                return process.env.NODE_ENV || defaultValue;
            case 'CASALABIA_AGENCY_B2C_API_HOST':
                return process.env.CASALABIA_AGENCY_B2C_API_HOST || defaultValue;
            case 'CASALABIA_AGENCY_B2C_INTERNAL_API_HOST':
                return process.env.CASALABIA_AGENCY_B2C_INTERNAL_API_HOST || defaultValue;
            case 'CASALABIA_AGENCY_B2C_API_PREFIX':
                return process.env.CASALABIA_AGENCY_B2C_API_PREFIX || defaultValue;
            default:
                return defaultValue;
        }
    }
    catch (e) {
        return defaultValue;
    }
};
// Определяем окружение
const isRailwayEnvironment = typeof window !== 'undefined' && window.location.hostname.includes('.railway.app');
const isProductionBuild = getEnvVar('NODE_ENV', 'development') === 'production';
// Получаем хосты из переменных окружения или используем дефолтные
const INTERNAL_HOST = getEnvVar('CASALABIA_AGENCY_B2C_INTERNAL_API_HOST', 'http://ai-realtor-backend.railway.internal:8080');
const EXTERNAL_HOST = getEnvVar('CASALABIA_AGENCY_B2C_API_HOST', 'https://api.casalabia.dev');
// Выбираем хост в зависимости от окружения
export const HOST = isRailwayEnvironment && isProductionBuild
    ? INTERNAL_HOST
    : EXTERNAL_HOST;
export const API_PREFIX = getEnvVar('CASALABIA_AGENCY_B2C_API_PREFIX', '/api/v1');
// Для отладки в консоли (только в dev режиме)
if (getEnvVar('NODE_ENV', 'development') === 'development') {
    console.log('🌐 API Configuration:', {
        isRailwayEnvironment,
        isProductionBuild,
        selectedHost: HOST,
        apiPrefix: API_PREFIX,
        fullApiUrl: `${HOST}${API_PREFIX}`,
        envVars: {
            CASALABIA_AGENCY_B2C_API_HOST: getEnvVar('CASALABIA_AGENCY_B2C_API_HOST', ''),
            CASALABIA_AGENCY_B2C_INTERNAL_API_HOST: getEnvVar('CASALABIA_AGENCY_B2C_INTERNAL_API_HOST', ''),
            CASALABIA_AGENCY_B2C_API_PREFIX: getEnvVar('CASALABIA_AGENCY_B2C_API_PREFIX', '')
        }
    });
}
